import { defineStore } from "pinia";
import { getLeadStatus, getLeadStatusChanges } from "@/api/apiclient/lead";
import { getOrganizationStatus } from "@/api/apiclient/organization";
import { useSettings } from "@/store/settings";

export const useStatus = defineStore("status", {
  state: () => {
    return {
      invitationStatusCollection: [] as any[],
      allAvailableInvitationStatusEvolutions: [] as any[],
      organizationStatusCollection: [] as any[],
      projectStatusCollection: [
        { name: "Draft", color: "#737378" },

        { name: "Assigned", color: "#79ab0f" },
        { name: "Published", color: "#79ab0f" },
        { name: "Closed", color: "#79ab0f" },

        { name: "BudgetGenerated", color: "#598177" },
        { name: "BankPreparing", color: "#598177" },
        { name: "Loading", color: "#598177" },

        { name: "CommercialVerification", color: "#598177" },
        { name: "Revisioned", color: "#598177" },
        { name: "Contract1stApprovation", color: "#598177" },

        { name: "LoadingDocumentation", color: "#AB6B20" },
        { name: "DesignInProgress", color: "#AB6B20" },
        { name: "Invoicing", color: "#AB6B20" },

        { name: "BudgetConfirmed", color: "#308085" },
        { name: "Revisioning", color: "#308085" },
        { name: "PreliminaryValidation", color: "#308085" },
        { name: "RatingCompleted", color: "#308085" },

        { name: "MoneyLaunderingCompleted", color: "#c8257d" },
        { name: "Validation", color: "#c8257d" },

        { name: "PreCommitmentSigned", color: "#9d72d2" },
        { name: "WaitingValidation", color: "#9d72d2" },
        { name: "FinalChecking", color: "#9d72d2" },
        { name: "WaitingMoneyLaundering", color: "#9d72d2" },

        { name: "RatingRequested", color: "#9b7900" },
        { name: "RatingWaiting", color: "#4079b5" },

        { name: "KORating", color: "#c20606" },
        { name: "MoneyLaunderingKO", color: "#c20606" },
        { name: "CommercialKO", color: "#c20606" },
        { name: "Rejected", color: "#c20606" },
        { name: "TechnicalKO", color: "#c20606" },

        { name: "InCharge", color: "#122C4A" },
        { name: "FinancingOpened", color: "#122C4A" },
        { name: "RevisionGC", color: "#122C4A" },

        { name: "RevisionProf", color: "#BF5F12" },

        { name: "AcceptedProf", color: "#7C5DA4" },
        { name: "WaitingPayment", color: "#7C5DA4" },

        { name: "Completation", color: "#9D219F" },
        { name: "AcceptedGC", color: "#9D219F" },
        { name: "Completed", color: "#9D219F" },
      ] as any[],
    };
  },
  actions: {
    async loadInvitationStatuses(force = false) {
      if (this.invitationStatusCollection.length && !force) return;
      this.invitationStatusCollection.length = 0;
      const resStatus = await getLeadStatus();
      this.invitationStatusCollection.push(...(resStatus?.data ?? []));
    },

    async loadInvitationStatusEvolutions(force = false) {
      if (this.allAvailableInvitationStatusEvolutions.length && !force) return;
      this.allAvailableInvitationStatusEvolutions.length = 0;
      const resChanges = await getLeadStatusChanges();
      this.allAvailableInvitationStatusEvolutions.push(...(resChanges?.data ?? []));
    },

    async loadOrganizationStatuses(force = false) {
      if (this.organizationStatusCollection.length && !force) return;
      this.organizationStatusCollection.length = 0;
      const resOrgStatus = await getOrganizationStatus();
      this.organizationStatusCollection.push(...(resOrgStatus?.data ?? []));
    },

    // async setup(force = false) {
    //   // await this.loadInvitationStatuses(force);
    //   await this.loadInvitationStatusEvolutions(force);
    //   // await this.loadOrganizationStatuses(force);
    // },
    resetList(): void {
      this.invitationStatusCollection.length = 0;
      this.allAvailableInvitationStatusEvolutions.length = 0;
      this.organizationStatusCollection.length = 0;
    },
  },
  getters: {
    evolutionsByCurrentInvitationStatus: (state) => (status: string, type: string) => {
      return (
        state.allAvailableInvitationStatusEvolutions
          ?.filter(
            (item) =>
              item.application_id == useSettings().effectiveApplicationId &&
              item.entityType == type
          )
          ?.find((item) => item.source_status.toLowerCase() == status.toLowerCase())
          ?.destination_statuses ?? []
      );
    },
    // restituisce una stringa con la lista degli stati (filtrati se serve) separati da un separatore definito in input.
    getInvitationStatusCollectionStringified:
      (state) =>
      (sep: string = ",", omit?: string[]) =>
        state.invitationStatusCollection.filter((item) => !omit?.includes(item)).join(sep),

    getStatusColorByName: (state) => (status: string, type: string) => {
      switch (type) {
        case "Invitation":
          return (
            state.allAvailableInvitationStatusEvolutions.find(
              (item: any) => item.source_status.toLowerCase() === status.toLowerCase()
            )?.color || ""
          );
        case "Project":
          return (
            state.projectStatusCollection.find(
              (item: any) => item.name.toLowerCase() === status.toLowerCase()
            )?.color || ""
          );
      }
    },
  },
});
